export const paymentTypes = {
  accounting: 'Бухгалтерские услуги',
  ipn: 'ИПН',
  opv: 'ОПВ',
  opvr: 'ОПВР',
  so: 'СО',
  vosms: 'ВОСМС',
  osms: 'ОСМС',
  ipn_comp: 'ИПН с компаний',
  sn: 'СН',
  service: 'Услуга / Пакет услуг',
};

export const taxesSet = new Set([
  'ipn',
  'opv',
  'so',
  'vosms',
  'osms',
  'opvr',
  'ipn_com',
  'sn',
]);

export const paymentTypesArr = [
  { value: 'accounting', text: 'Бухгалтерские услуги' },
  { value: 'ipn', text: 'ИПН' },
  { value: 'opv', text: 'ОПВ' },
  { value: 'opvr', text: 'ОПВР' },
  { value: 'so', text: 'СО' },
  { value: 'vosms', text: 'ВОСМС' },
  { value: 'osms', text: 'ОСМС' },
  { value: 'service', text: 'Услуга / Пакет услуг' },
];

export const paymentTypesArrFilter = [
  { value: 'accounting', text: 'Бухгалтерские услуги' },
  { value: 'ipn', text: 'ИПН' },
  { value: 'opv', text: 'ОПВ' },
  { value: 'opvr', text: 'ОПВР' },
  { value: 'so', text: 'СО' },
  { value: 'vosms', text: 'ВОСМС' },
  { value: 'osms', text: 'ОСМС' },
  { value: 'ipn_comp', text: 'ИПН с компаний' },
  { value: 'sn', text: 'СН' },
  { value: 'service', text: 'Услуга / Пакет услуг' },
];

export const bccPaymentsStatusFilters = [
  { text: 'Создан', value: 'created' },
  { text: 'Отправлен в БЦК', value: 'bcc_sended' },
  { text: 'Ошибка при отправке в банк', value: 'error_sent_bcc' },
];

export const clientPaymentStatusesSelect = [
  { value: 'created', text: 'Сформирован' },
  { value: 'on_payment', text: 'На оплате (у клиента)' },
  { value: 'paid', text: 'Оплачен' },
  { value: 'paid_kgd', text: 'Отправлен в КГД' },
  { value: 'paid_gfc', text: 'Отправлен в ПДГ' },
  { value: 'refund', text: 'Возвращено' },
  { value: 'error_payment_payda', text: 'Ошибка при оплате в системе' },
  { value: 'error_payment_card', text: 'Ошибка при оплате в процессинге' },
  { value: 'error_sent_bcc', text: 'Ошибка при отправке в банк' },
  { value: 'error_payment_bcc', text: 'Ошибка при оплате в банке' },
  { value: 'error_payment_kgd', text: 'Ошибка при оплате в КГД' },
  { value: 'error_payment_gfc', text: 'Ошибка при оплате в ПДГ' },
  { value: 'paid_another', text: 'Оплачен через другой сервис' },
];

export const clientPaymentStatuses = {
  created: 'Сформирован',
  on_payment: 'На оплате (у клиента)',
  paid: 'Оплачен',
  paid_kgd: 'Отправлен в КГД',
  paid_gfc: 'Отправлен в ПДГ',
  refund: 'Возврат',
  cancel: 'Отклонен админом',
  error_payment_payda: 'Ошибка при оплате в системе',
  error_payment_card: 'Ошибка при оплате в процессинге',
  error_sent_bcc: 'Ошибка при отправке в банк',
  error_payment_bcc: 'Ошибка при оплате в банке',
  error_payment_kgd: 'Ошибка при оплате в КГД',
  error_payment_gfc: 'Ошибка при оплате в ПДГ',
  error_payment_partner: 'Ошибка при отправке на счет партнера',
  error_no_partner_account: 'Нет счета у партнера',
  error_no_manager: 'Клиент не привязан к бухгалтеру',
  accept_bcc: 'Подтвержден в БЦК',
  sent_bcc: 'Отправлен в БЦК',
  sent_to_transit: 'Отправлен в Транзитный счет',
  error_sent_transit: 'Ошибка отправки в Транзитный счет',
  sent_account: 'Отправлен на бух. счет',
  sent_to_account: 'Отправлен на бух. счет',
  error_sent_account: 'Ошибка отправки на бух. счет',
  processing_token: 'В обработке',
  paid_another: 'Оплачен через другой сервис',
};

export const paymentStatuses = [
  { value: 'Создан', key: 'created' },
  { value: 'В обработке', key: 'processing_token' },
  { value: 'Оплачен', key: 'paid' },
  { value: 'Проведен', key: 'success' },
  { value: 'Не проведён', key: 'error_send_all' },
  { value: 'Частично проведён', key: 'partly_success' },
  { value: 'Ошибка', key: 'error' },
  { value: 'Возврат', key: 'refund' },
  { value: 'Отменен', key: 'cancel' },
  { value: 'Отправлен на бух.счет', key: 'sent_account' },
  { value: 'Отправлен на бух.счет', key: 'sent_to_account' },
  { value: 'Отправлен в транзитный счет', key: 'sent_transit' },
  { value: 'Ошибка отправки на транзит.счёт', key: 'error_sent_transit' },
  { value: 'Ошибка отправки на бух.счёт', key: 'error_sent_account' },
  { value: 'Недостаточно денег', key: 'not_enough_money' },
  { value: 'Отправлен на транзит.счёт (visa)', key: 'sent_to_transit_visa' },
];

export const paymentStatusToText = {
  error: 'Ошибка',
  paid: 'Оплачен',
  created: 'Создан',
  success: 'Проведен',
  error_send_all: 'Не проведён',
  partly_success: 'Частично проведён',
  cancel: 'Отменен',
  sent_account: 'Отправлен на бух.счет',
  sent_to_account: 'Отправлен на бух.счет',
  sent_transit: 'Отправлен в транзитный счет',
  refund: 'Возврат',
  error_sent_transit: 'Ошибка отправки на транзит.счёт',
  error_sent_account: 'Ошибка отправки на бух.счёт',
  processing_token: 'В обработке',
  not_enough_money: 'Недостаточно денег',
  sent_to_transit_visa: 'Отправлен на транзит.счёт (visa)',
};

export const cardPaymentType = {
  acquiring: 'Эквайринг',
  kaspi: 'Каспий',
  card_token: 'Сохраненная карта',
  acquiring_recurrent: 'Подписка',
};

export const cardPaymentTypesList = [
  { key: 'acquiring', value: 'Эквайринг' },
  { key: 'acquiring_recurrent', value: 'Подписка' },
  { key: 'kaspi', value: 'Каспий' },
  { key: 'card_token', value: 'Сохраненная карта' },
];

export const updateStatuses = [
  { value: 'created', text: 'Сформирован' },
  { value: 'on_payment', text: 'На оплате (у клиента)' },
  { value: 'paid_another', text: 'Оплачен через другой сервис' },
];
